import React from 'react';
import Grid from '@material-ui/core/Grid';

import ScreenHeader from 'core/components/screen-header';
import { Label } from 'core/components/label';
import useSession from 'core/hooks/use-session';
import useStyles from './header.styles';

const UserProfileHeader = () => {
  const classes = useStyles();
  const session = useSession();
  const legacyAffinityCode = session?.userPreferences?.legacyAffinityCode;

  const subtitles = legacyAffinityCode ? (
    <Grid container>
      <Grid container item direction="row" alignItems="baseline">
        <Label className={classes.subtitle} type="infoLabel">
          Agency affinity from Guidewire
        </Label>
        <Label type="infoValue">{legacyAffinityCode}</Label>
      </Grid>
    </Grid>
  ) : undefined;

  return (
    <Grid container className={classes.headerWrapper}>
      <Grid className={classes.titleWrapper} container item xs={10}>
        <ScreenHeader title="Profile" subtitles={subtitles} options={{ hideBackButton: true }} />
      </Grid>
    </Grid>
  );
};

export default UserProfileHeader;
